import React, { useContext, useState, useEffect } from 'react';
import { ChatContext } from '../context/ChatContext';
import axios from 'axios';
import { Menu } from '@headlessui/react';
import { ASSISTANT_CHAT_HISTORY_URL } from '../constants';
import { AuthContext } from '../context/AuthContext';

const SideMenu = ({isOpen, setIsOpen}) => {
    const CHAT = useContext(ChatContext);
    const [chatMenu, setChatMenu] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const { user } = useContext(AuthContext);
    const userId = user?.username || user?.IDalumno;

    useEffect(() => {
        setChatMenu(CHAT.chatMenu);
    }, [CHAT.chatMenu]);

    const handleChange = async (folderName) => {        
        if (!userId) return;
        CHAT.setChatShow(true);
        setIsOpen(!isOpen)
        try {
            const res = await axios.post(ASSISTANT_CHAT_HISTORY_URL, { folderName, userId }, {
                headers: {                    
                    'Content-Type': 'application/json',
                },
            });
            CHAT.setChatMessage(res.data.menu);
            CHAT.setShowChatTime(res.data.folder);
        } catch (error) {
            console.error("Error fetching chat history:", error);
        }
    };

    const handleDelete = async (folderName) => {
        if (!userId) return;
        try {
            await axios.delete(ASSISTANT_CHAT_HISTORY_URL, {
                data: { folderName, userId },
                headers: {                    
                    'Content-Type': 'application/json',
                },
            });
            setChatMenu(chatMenu.filter(item => item.folder !== folderName));
            setDropdownOpen(null);
        } catch (error) {
            console.error("Error deleting chat history:", error);
        }
    };

    const toggleDropdown = (index) => {
        setDropdownOpen(dropdownOpen === index ? null : index);
    };

    return (
        <div className="bg-white w-full max-w-full h-full px-6 py-10 overflow-y-auto">
            <h1 className="mb-4">Historia</h1>
            <div className="space-y-4 max-h-[80vh]">
                {chatMenu.map((item, index) => (
                    <div key={index} className={`flex p-1 items-start justify-between relative ${CHAT.showChatTime === item.folder ? 'rounded-lg bg-gray-100' : ''}`}>
                        <button onClick={() => handleChange(item.folder)} className="flex flex-col">
                            <label className="font-medium">{item.question.length <= 30 ? item.question : item.question.slice(0, 30) + '...'}</label>
                        </button>

                        <div className="relative">
                            <button onClick={() => toggleDropdown(index)} className="text-gray-500 hover:text-gray-700 text-lg font-medium ml-4 focus:outline-none">
                                ...
                            </button>

                            {dropdownOpen === index && (
                                <Menu as="div" className="absolute right-0 mt-2 w-28 bg-white shadow-lg rounded-md z-10">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                onClick={() => handleDelete(item.folder)}
                                                className={`${active ? 'bg-red-50' : ''} text-black-500 hover:text-red-700 w-full text-left px-4 py-2 text-sm font-medium`}
                                            >
                                                <i className="fas fa-trash"></i> &nbsp; Borrar
                                            </button>
                                        )}
                                    </Menu.Item>
                                </Menu>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SideMenu;
